import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { Ge as h, hi as g, D as f, T as b, bo as d, M as p, fi as u } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as v } from "./state-b4c9cc73-ee633f6c.js";
import { A as m } from "./query-assigned-ba663908-228b08f4.js";
var y = h(_templateObject || (_templateObject = _taggedTemplateLiteral([":is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) :is(h1,h2,h3,h4,h5,h6,p){margin:0;padding:0}:is([beacon-tag-name=beacon-navigation-expanded],[beacon-tag-name=beacon-navigation-footer]) ::part(button){text-align:inherit}\n"]))),
  x = h(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));inline-size:100%}::slotted(a),::slotted([beacon-tag-name=beacon-navigation-button]),[beacon-tag-name=beacon-navigation-button]{display:block;inline-size:fit-content;padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}::slotted([slot=title]){color:var(--beacon-system-color-text-title, var(--heritage-navigation-expanded-title-color, var(--beacon-color-text-default-on-light)));font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-300, var(--beacon-headline-font-size-200)/var(--beacon-headline-font-line-height-module-200) var(--beacon-font-family-default))}::slotted([slot=description]){font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));color:var(--beacon-system-color-text-standard, var(--heritage-navigation-expanded-text-color, var(--beacon-color-text-default-on-light)))}.title-area{padding-block:var(--beacon-system-space-cell-free-floating, var(--beacon-unit-atomic))}.title-area>*+*{margin-block-start:var(--navigation-expanded-title-area-gap, var(--beacon-unit-atomic))}.slot-container{display:grid;gap:var(--beacon-reference-space-2, var(--beacon-unit-subatomic))}@media (min-width: 960px){.level-2 .slot-container{columns:var(--expanded-nav-grid-template);display:block}.level-2,.level-3{padding-inline-end:var(--beacon-reference-space-7, 1.5rem)}}\n"])));
var N = Object.defineProperty,
  S = Object.getOwnPropertyDescriptor,
  o = function o(c, e, t, i) {
    for (var a = i > 1 ? void 0 : i ? S(e, t) : e, s = c.length - 1, l; s >= 0; s--) (l = c[s]) && (a = (i ? l(e, t, a) : l(a)) || a);
    return i && a && N(e, t, a), a;
  };
var n = /*#__PURE__*/function (_g) {
  _inherits(r, _g);
  function r() {
    var _this;
    _classCallCheck(this, r);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(r).apply(this, arguments)), _this.level = 1, _this.splitColumns = "true", _this.hasNestedExpandedNavigations = !1, _this.handleCurrentLink = function () {
      _this.currentLink && f(_assertThisInitialized(_assertThisInitialized(_this)), b.HAS_CURRENT_LINK);
    };
    return _this;
  }
  _createClass(r, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      _get(_getPrototypeOf(r.prototype), "firstUpdated", this).call(this), this.handleCurrentLink();
    } /** Set the level property. Runs on slotchange as it is dependent on nested menus. */
  }, {
    key: "setLevel",
    value: function setLevel() {
      this.level = 1 + (this.parentElement instanceof r ? this.parentElement.level : 0);
    } /** Updates based on this component having nested expanded navigations. */
  }, {
    key: "setNestedState",
    value: function setNestedState() {
      this.hasValidNestedItems.length > 0 ? this.hasNestedExpandedNavigations = !0 : this.hasNestedExpandedNavigations = !1;
    } /** Calculate a number of CSS columns based on how many links are to be shown. */
  }, {
    key: "calculateCSSColumns",
    value: function calculateCSSColumns(e) {
      var t = "";
      return e < 6 ? t = "1" : e < 11 ? t = "2" : e < 22 ? t = "3" : t = "4", t;
    } /** Calculate the grid template based on how many sections are shown. */
  }, {
    key: "calculateGridColumnTemplate",
    value: function calculateGridColumnTemplate(e) {
      var t = "";
      return e === 1 ? t = "1fr" : e === 2 ? t = "1fr 1fr" : e === 3 ? t = "1fr 1fr 1fr" : e >= 4 && (t = "1fr 1fr 1fr 1fr"), t;
    }
  }, {
    key: "setColumnsCSSProperty",
    value: function setColumnsCSSProperty(e) {
      this.style.setProperty("--expanded-nav-grid-template", e);
    }
  }, {
    key: "setNestedGridTemplates",
    value: function setNestedGridTemplates(e) {
      var t = this.calculateCSSColumns(e);
      this.setColumnsCSSProperty(t);
    }
  }, {
    key: "setLevel1GridTemplate",
    value: function setLevel1GridTemplate(e) {
      var t = this.calculateGridColumnTemplate(e);
      this.setColumnsCSSProperty(t);
    }
  }, {
    key: "setLevel2GridTemplate",
    value: function setLevel2GridTemplate(e) {
      this.setNestedGridTemplates(e);
    }
  }, {
    key: "setGridTemplates",
    value: function setGridTemplates() {
      var e = this.links.length;
      this.splitColumns === "false" && (e = 1), this.level === 1 ? this.setLevel1GridTemplate(e) : this.level === 2 ? this.setLevel2GridTemplate(e) : this.level === 3 && this.setNestedGridTemplates(e);
    }
  }, {
    key: "handleTitleSlotchange",
    value: function handleTitleSlotchange() {
      var e;
      this.titleSlotVal = (e = this.titleNodes) != null && e.length && this.titleNodes[0] instanceof HTMLElement ? this.titleNodes[0].innerText : "";
    }
  }, {
    key: "handleDefaultSlotchange",
    value: function handleDefaultSlotchange() {
      this.setNestedState(), this.setLevel(), this.setGridTemplates();
    }
  }, {
    key: "renderExpanded",
    value: function renderExpanded() {
      return d(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      <section class=\"header-zone\">\n        <div class=\"title-area\">\n          <div class=\"title-container\">\n            <slot name=\"title\" part=\"title\" @slotchange=", "></slot>\n          </div>\n        </div>\n      </section>\n      <section class=\"slot-container\">\n        <slot @slotchange=", "></slot>\n      </section>\n    "])), this.handleTitleSlotchange, this.handleDefaultSlotchange);
    }
  }, {
    key: "render",
    value: function render() {
      return d(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<div class=\"level-", "\">", "</div> "])), this.level, this.renderExpanded());
    }
  }, {
    key: "currentLink",
    /** Anchor link representing the current page. */get: function get() {
      return this.querySelector('a[aria-current="page"]');
    }
  }, {
    key: "hasValidNestedItems",
    get: function get() {
      return this.links.filter(function (e) {
        return (e instanceof r || e instanceof HTMLAnchorElement) && !(e instanceof HTMLStyleElement);
      });
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(r), "styles", this), x];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(r), "lightDOMStyles", this), y];
    }
  }]);
  return r;
}(g(u));
o([p({
  reflect: !0
})], n.prototype, "level", 2);
o([p({
  attribute: "split-columns",
  reflect: !0
})], n.prototype, "splitColumns", 2);
o([v()], n.prototype, "titleSlotVal", 2);
o([v()], n.prototype, "hasNestedExpandedNavigations", 2);
o([m({
  slot: "",
  flatten: !0
})], n.prototype, "links", 2);
o([m({
  slot: "title",
  flatten: !0
})], n.prototype, "titleNodes", 2);
var k = n;
var E = {
  beaconTagName: "beacon-navigation-expanded",
  beaconFooterNavTagName: "beacon-navigation-footer",
  navItemTagName: "beacon-navigation-button",
  maxLevel: 4
};
export { E as B, k as L };